<template>
  <div :class="fullScreen ? 'video-box' : ''">
    <video-player
      class="video-player vjs-custom-skin"
      ref="videoPlayer"
      :playsinline="true"
      :options="playerOptions()"
      @loadeddata="onLoadedData"
      :style="styles"
    ></video-player>
  </div>
</template>

<script>
export default {
  props: {
    // 是否渲染
    isPlayDemoVideo: {},
    // 视频链接
    videoUrl: {},
    // 是否开启满屏 配合model 全屏使用
    fullScreen: {
      default: false,
    },
    // 样式
    styles: {
      default: () => {
        return {}
      },
    },
  },
  watch: {
    isPlayDemoVideo: function (newval) {
      this.$refs.videoPlayer.player.pause()
    },
  },
  methods: {
    /** 监听视频 */
    onLoadedData(player) {
      console.log(player)
    },
    playerOptions() {
      const playerOptionsObj = {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //视频播放速度
        autoplay: false, // 如果true，浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）。
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）。
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: 'video/mp4', // 资源格式写法：'video/mp4'，否则控制台会出现notSupportedMessage设置的错误。
            src: this.videoUrl, // 视频url地址
          },
        ],
        poster: '', // 视频封面地址
        // width: document.documentElement.clientWidth,
        // height: document.documentElement.clientHeight, // 设置高度，fluid需要设置成flase
        notSupportedMessage: '此视频暂无法播放...', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
      }
      return playerOptionsObj
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  height: 100%;
}
.video-box {
  height: 100% !important;
  /deep/ .video-js .vjs-tech {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
  }
  /deep/ .video-player.video-player.vjs-custom-skin {
    height: 100%;
  }
  /deep/ .video-js.vjs-fluid,
  .video-js.vjs-16-9,
  .video-js.vjs-4-3 {
    width: 100% !important;
    height: 100% !important;
    padding-top: 0 !important;
  }
  /deep/ .video-js.vjs-fullscreen {
    width: 100% !important;
    height: 100% !important;
    padding-top: 0 !important;
  }
}
</style>